import { useEffect, useRef, useState } from "react";
import { parseFileResponse, parseResponse } from "lib/fetch";
import { getFileBySlugRefRequest, getFileRequest } from "lib/api/file";

export const fetchFile = (id: string) => parseFileResponse(getFileRequest(id));

export const fetchFileBySlugRef = (slugRefFile: string) => parseResponse<unknown>(getFileBySlugRefRequest(slugRefFile));

interface UseFileObjectUrlOptions {
    onFetchError?: (err: unknown) => void;
}

export function useFileObjectUrl(
    id: string | undefined | null,
    options: UseFileObjectUrlOptions = {},
): string | undefined {
    const { onFetchError } = options;
    const onFetchErrorRef = useRef(onFetchError);
    onFetchErrorRef.current = onFetchError;

    const [objectUrl, setObjectUrl] = useState<string | undefined>();

    useEffect(() => {
        if (!id) {
            setObjectUrl(undefined);
            return;
        }

        let url: string | undefined;
        let cancelled = false;

        void fetchFile(id)
            .then((file) => {
                if (cancelled) return;
                url = URL.createObjectURL(file.content);
                setObjectUrl(url);
            })
            .catch((err) => {
                console.error("[useFileObjectUrl]", err);
                if (!cancelled) onFetchErrorRef.current?.(err);
            });

        return () => {
            cancelled = true;
            if (url) URL.revokeObjectURL(url);
        };
    }, [id]);

    return objectUrl;
}
